import router from '../routes'
import {
    getCookie
} from "@/utils/index.js";

router.afterEach((to, from, next) => {
    console.log(to)
    console.log(from)
    console.log(next)
    if (getCookie('CHANG_CHENG_COOKIE') == "true") {
        window.gtag('config', 'G-94F3XF0ZT0', {
            'anonymize_ip': true,
            page_title: to.name,
            page_path: to.path,
            page_location: to.path,
        })
    }
})